import { render } from "./PlaytestPopup.vue?vue&type=template&id=c1372b88&scoped=true"
import script from "./PlaytestPopup.vue?vue&type=script&lang=js"
export * from "./PlaytestPopup.vue?vue&type=script&lang=js"

import "./PlaytestPopup.vue?vue&type=style&index=0&id=c1372b88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1372b88"]])

export default __exports__